// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue"; //调取vue.js文件(使用import命令加载的Vue构建版本)
import App from "./App"; //引入App.vue文件
import router from "./router"; //引入路由文件？
import ElementUI from "element-ui";
import jquery from "jquery";
window.jquery = window.$ = jquery;
import VueResource from "vue-resource";
//引入第三方axios
import axios from "axios";
//配置访问服务器基础路径
axios.defaults.baseURL = "https://www.credpay.ng";
//每次访问服务器将session  id发送服务器验证使用
axios.defaults.withCredentials = true;
//将axios注册Vue实例中,
//注意顺序:不能配置在Vue后面
Vue.prototype.axios = axios;

/*插件css*/
import "element-ui/lib/theme-chalk/index.css";

// 引入公共样式
import "./public.css";

Vue.use(ElementUI);
Vue.use(VueResource);

Vue.config.productionTip = false;

//引入第三方vuex
//引入vuex
import Vuex from "vuex";
//注册vuex
Vue.use(Vuex); /*实例化一个Vue对象 */
/* eslint-disable no-new */ new Vue({
  //实例化对象
  el: "#app", //当前vue要控制的容器元素（这里是index.html中的id为app的div）
  router, //配置路由？
  template: "<App/>", //模板：对应的组件调用的标签
  components: { App } //组件注册：components。App就是注册的文件，来源于App.vue
});

// WEBPACK FOOTER //
// ./src/main.js



// WEBPACK FOOTER //
// ./src/main.js